import { Autocomplete, FormControl, TextField } from "@mui/material";
import React from "react";
import { Controller, useForm, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

const views = ["week", "day", "agenda"];

export default function ChangeCalendarView({ defaultCalendarView }) {
  const { t } = useTranslation();
  const methods = useFormContext();

  if (!defaultCalendarView) {
    defaultCalendarView = "agenda";
  }

  return (
    <Controller
      name={"defaultCalendarView"}
      control={methods.control}
      render={({ field }) => (
        <FormControl fullWidth {...methods.register("defaultCalendarView")}>
          <Autocomplete
            options={views}
            defaultValue={views.find(
              (view) => String(view) === String(defaultCalendarView),
            )}
            getOptionLabel={(option) => t(option)}
            onChange={(event, value) => field.onChange(value)}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t("defaultCalendarView")}
                inputProps={{
                  ...params.inputProps,
                  "data-testid": "profile.settings.calendar-view-input",
                }}
              />
            )}
            renderOption={(props, option) => <li {...props}>{t(option)}</li>}
            fullWidth
            clearText={t("Clear")}
            closeText={t("Close")}
            openText={t("Open")}
          />
        </FormControl>
      )}
    />
  );
}
